(() => {
  const init = (root) => {
    if (root.dataset.shReady) return;
    root.dataset.shReady = 'true';
    const form = root.querySelector('form.sh-purchase-form');
    const variants = JSON.parse(root.querySelector('[data-sh-variants]').textContent);
    const messages = JSON.parse(root.querySelector('[data-sh-messages]').textContent);
    const money = new Intl.NumberFormat(messages.locale, {style:'currency',currency:messages.currency});
    const currencyStep = 10 ** (2 - money.resolvedOptions().maximumFractionDigits);
    const roundMoney = value => Math.round(value / currencyStep) * currencyStep;
    const offerRate = messages.currency === messages.offerCurrency ? 1 : Number(window.Shopify?.currency?.rate || 0);
    const priceOf = id => variants.find(v => String(v.id) === String(id))?.price || 0;
    const selectedId = () => form.querySelector('input[name="id"]:checked')?.value;
    const count = () => Number(form.querySelector('input[name="quantity"]:checked')?.value || 1);
    const update = () => {
      const quantity = count();
      root.querySelector('[data-sh-extra]').hidden = quantity === 1;
      root.querySelectorAll('[data-sh-extra-row]').forEach(row => row.hidden = Number(row.dataset.shExtraRow) > quantity);
      root.querySelector('[data-sh-price]').textContent = money.format(priceOf(selectedId()) / 100);
      const selected = variants.find(variant => String(variant.id) === String(selectedId()));
      const comparePrice = Number(selected?.compareAtPrice || 0);
      const discounted = comparePrice > priceOf(selectedId());
      const compare = root.querySelector('[data-sh-compare]');
      const badge = root.querySelector('[data-sh-discount]');
      compare.hidden = !discounted;
      badge.hidden = !discounted;
      compare.textContent = money.format(comparePrice / 100);
      if (discounted) root.querySelector('[data-sh-percent]').textContent = Math.round((1 - priceOf(selectedId()) / comparePrice) * 100);
      root.querySelectorAll('[data-sh-total]').forEach(label => {
        const n = Number(label.dataset.shTotal);
        const ids = [selectedId()];
        for (let i = 2; i <= n; i++) ids.push(root.querySelector(`[data-sh-extra-size="${i}"]`).value);
        const discount = roundMoney(Number(messages.discounts[n] || 0) * offerRate);
        const total = ids.reduce((sum, id) => sum + Math.max(0, priceOf(id) - discount), 0);
        label.textContent = money.format(total / 100);
        const comparison = root.querySelector(`[data-sh-compare-total="${n}"]`);
        const comparisonTotal = n > 1 ? ids.reduce((sum, id) => sum + priceOf(id), 0) : comparePrice;
        comparison.hidden = comparisonTotal <= total;
        comparison.textContent = money.format(comparisonTotal / 100);
        const unit = root.querySelector(`[data-sh-unit="${n}"]`);
        if (unit) unit.textContent = money.format(total / n / 100);
      });
    };
    form.addEventListener('change',update);
    const dialog = root.querySelector('[data-sh-dialog]');
    root.querySelectorAll('[data-sh-zoom]').forEach(button => button.addEventListener('click', () => {
      const source = button.querySelector('img');
      const image = dialog.querySelector('[data-sh-zoom-image]');
      image.src = button.dataset.shFull || source.currentSrc || source.src;
      image.alt = source.alt;
      dialog.showModal();
    }));
    dialog.querySelector('[data-sh-close]').addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', event => { if (event.target === dialog) dialog.close(); });
    root.querySelector('[data-sh-fit]').addEventListener('click',()=>{const details=root.querySelector('[data-sh-fit-details]');details.open=true;details.scrollIntoView({behavior:'smooth',block:'center'});});
    root.querySelectorAll('[data-sh-thumb]').forEach(button => button.addEventListener('click', () => {
      const index = button.dataset.shThumb;
      root.querySelectorAll('[data-sh-slide]').forEach(slide => slide.hidden = slide.dataset.shSlide !== index);
      root.querySelectorAll('[data-sh-thumb]').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
    }));
    form.addEventListener('submit',async event => {
      event.preventDefault();
      const button = form.querySelector('[data-sh-add]');
      if (button.disabled) return;
      const label = button.querySelector('span');
      const original = label.textContent;
      const error = form.querySelector('[data-sh-error]');
      button.disabled = true;
      label.textContent = messages.adding;
      error.hidden = true;
      try {
        const ids = [selectedId()];
        for (let i=2;i<=count();i++) ids.push(root.querySelector(`[data-sh-extra-size="${i}"]`).value);
        const grouped = new Map();
        ids.forEach(id => grouped.set(id,(grouped.get(id)||0)+1));
        const response = await fetch(root.dataset.addUrl,{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[...grouped].map(([id,quantity])=>({id:Number(id),quantity}))})});
        if (!response.ok) {
          const result = await response.json();
          throw new Error(result.description || messages.error);
        }
        window.location.assign(root.dataset.cartUrl);
      } catch (failure) {
        error.textContent = failure.message || messages.error;
        error.hidden = false;
        button.disabled = false;
        label.textContent = original;
      }
    });
    const sticky = root.querySelector('[data-sh-sticky]');
    const observer = new IntersectionObserver(entries=>{sticky.hidden=entries[0].isIntersecting || entries[0].boundingClientRect.top > 0;},{threshold:0});
    observer.observe(form.querySelector('[data-sh-add]'));
    update();
  };
  document.querySelectorAll('.sh-mobile-menu a').forEach(link=>link.addEventListener('click',()=>link.closest('details').open=false));
  document.querySelectorAll('[data-sh-product]').forEach(init);
  document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('[data-sh-product]').forEach(init));
})();
